<template>
  <div class="orbit english_container">
    <myHeader />
    <div class="bg">
      <div class="contain">
        <h1 class="wow fadeInUp enProductTitle" style="font-size: 80px;line-height: normal;">hecoos Mirror Projection Track Lens</h1>
        <p class="wow fadeInUp enTwoProductTitle" style="line-height: 40px;">
          The hecoos Mirror Projection Track Lens provides flexible and diverse control over projection images, eliminating the limitations of fixed projectors that are restricted to projecting in a single, fixed direction on a surface.
        </p>

        <div class="contain_button">

          <router-link :to="{
            name: 'enCaseDemonstration',
            hash: '#specific-position',
          }" class="setting_a2">
            <button class="contact-button wow fadeInUp">Contact Us</button>
          </router-link>
        </div>
      </div>
    </div>

    <!-- <div class="swiper-slide">
      <div class="carousel-content">
        <video class="video_young" autoplay loop muted
          src="https://download.hecoos.com/enlightv/2025-11/639b0bf986e055fad0427e2ebd9c95ef.mp4"></video>
        <div class="carousel-overlay">
          <p class="carousel-title wow fadeInUp">点亮新视野</p>
          <button class="watch-movie-button wow fadeInUp" @click="showVideo(0)">
            <img src="https://download.hecoos.com/enlightv/2025-17/474eb090ad7a5003fcc3f12e09a7120a.png" alt="" />
          </button>
        </div>
      </div>
    </div> -->

    <div class="section_foundation">
      <div class="section_content">
        <!-- <p class="carousel-title wow fadeInUp">Illuminate a New Vision</p> -->
         <p class="carousel-title wow fadeInUp">Illuminating Visions</p>
        <button class="watch-movie-button wow fadeInUp" @click="showVideo">
          <img src="https://download.hecoos.com/enlightv/2025-17/474eb090ad7a5003fcc3f12e09a7120a.png" alt="" />
        </button>
      </div>
      <div class="scroll_container">
        <div class="foundation_video">
          <video autoplay loop muted
            src="https://download.hecoos.com/enlightv/2025-11/639b0bf986e055fad0427e2ebd9c95ef.mp4"></video>
        </div>
      </div>
    </div>

    <div class="bg2">
      <div class="bg22">
        <p class="wow fadeInUp">Hardware Specifications</p>
        <h1 class="wow fadeInUp enProductTitle">Detailed parameter overview</h1>
        <img src="https://download.hecoos.com/enlightv/2025-17/33df240596d55557bc9cbf984cfa9f0c.png"
          class="wow fadeInUp" />
      </div>
    </div>

    <div class="bg3">
      <div>
        <div class="content1 wow fadeInUp">
          <div class="con11">
            <h1>Technical<br/>Specifications</h1>
          </div>
          <div class="con1">
            <p>Device Dimensions (W/D/H):</p>
            <p>Device Weight:</p>
            <p>Projection Module Weight:</p>
            <p>Single Mirror Weight:</p>
            <p>Truss-Mounted Bracket MHZ-BT Weight:</p>
            <p>Wall-Mounted Bracket MHZ-BW Weight:</p>
            <p>Extended Mounting Bracket MHZ-BT-BW Weight:</p>
            <p>Base Weight MHZ-BSH:</p>
          </div>
          <div class="con2">
            <p>{{ specParams.deviceSize }}</p>
            <p>{{ specParams.totalWeight }}</p>
            <p>{{ specParams.projectorWeight }}</p>
            <p>{{ specParams.mirrorWeight }}</p>
            <p>{{ specParams.btMountWeight }}</p>
            <p>{{ specParams.bwMountWeight }}</p>
            <p>{{ specParams.beMountWeight }}</p>
            <p>{{ specParams.bshMountWeight }}</p>
          </div>
        </div>
        <div class="content2 wow fadeInUp">
          <div class="con11">
            <h1>Electrical<br/>Specifications</h1>
          </div>
          <div class="con1">
            <p>Input Power:</p>
            <p>Output Power：</p>
          </div>
          <div class="con2">
            <p>{{ electricSpecs.inputPower }}</p>
            <p>{{ electricSpecs.outputPower }}</p>
          </div>
        </div>
        <div class="content3 wow fadeInUp">
          <div class="con11">
            <h1>Operational<br/>Specifications</h1>
          </div>
          <div class="con1">
            <p>Track mirror tilt mode：</p>
            <p>Track mirror pan mode:</p>
            <p>Positioning accuracy error：</p>
            <p>Relocation Accuracy：</p>
          </div>
          <div class="con2">
            <p>{{ operationSpecs.tiltMode }}</p>
            <p>{{ operationSpecs.panMode }}</p>
            <p>{{ operationSpecs.positionError }}</p>
            <p>{{ operationSpecs.movementPrecision }}</p>
          </div>
        </div>
        <div class="content4 wow fadeInUp">
          <div class="con11">
            <h1>Operating<br/>Environment</h1>
          </div>
          <div class="con1">
            <p>Working Temperature Range:5°-35°C</p>
            <p>Humidity:20%-80%(non-condensing)</p>
          </div>
          <div class="con2"></div>
        </div>
        <div class="content5 wow fadeInUp">
          <div class="con11">
            <h1>Included<br/>Accessories</h1>
          </div>
          <div class="con1">
            <p>RS232 Connection Cable</p>
            <p>AC circuit cable</p>
            <p>Quick Setup Guide</p>
          </div>
          <div class="con2"></div>
        </div>
      </div>
    </div>

    <div class="titlebg4">
      <div>
        <div class="bg4text1">
          <h1 class="enProductTitle">Project Showcase</h1>
        </div>
      </div>
    </div>

    <!-- <div class="swiper-slide">
      <div class="carousel-content">
        <video class="video_young" autoplay loop muted
          src="https://download.hecoos.com/enlightv/2025-11/4dbbdd6f1ceda8ebe264e9e876155cbd.mp4"></video>
        <div class="carousel-overlay">
          <button class="watch-movie-button wow fadeInUp" @click="showVideo(1)">
            <img src="https://download.hecoos.com/enlightv/2025-17/474eb090ad7a5003fcc3f12e09a7120a.png" alt="" />
          </button>
        </div>
      </div>
    </div> -->

    <div class="section_foundation">
      <div class="section_content">
        <!-- <p class="carousel-title wow fadeInUp">点亮新视野</p> -->
        <button class="watch-movie-button wow fadeInUp" @click="showVideo(1)">
          <img src="https://download.hecoos.com/enlightv/2025-17/474eb090ad7a5003fcc3f12e09a7120a.png" alt="" />
        </button>
      </div>
      <div class="scroll_container">
        <div class="foundation_video">
          <video autoplay loop muted ref="videoRef"
            src="https://download.hecoos.com/enlightv/2025-17/4339ee88fdfb051af80a4a26f1830572.mp4"></video>
        </div>
      </div>
    </div>

    <div class="bg4">
      <div>
        <div class="bg4text">
          <div class="qq1">
            <h3 class="qq wow fadeInUp">{{ textaerass.titletext }}</h3>
            <p class="wow fadeInUp">{{ textaerass.pagetext }}</p>
          </div>
        </div>
      </div>
    </div>

    <my-inquire />
    <my-footer />
    <BackToTop></BackToTop>
    <videoPlayback v-if="showVideoPlayer" @close="handleCloseVideo" :videoUrl="videoUrl" />
  </div>
</template>

<script>
import myFooter from "@/components/en_pc/myFooter.vue";
import myHeader from "@/components/en_pc/myHeader.vue";
import myInquire from "@/components/en_pc/myInquire.vue";
import BackToTop from "@/components/en_pc/BackToTop";
import videoPlayback from "@/components/en_pc/videoPlayback.vue";
export default {
  components: {
    myHeader,
    myFooter,
    myInquire,
    BackToTop,
    videoPlayback,
  },

  data() {
    return {
      showVideoPlayer: false,
      videoUrl: "https://download.hecoos.com/enlightv/2025-11/639b0bf986e055fad0427e2ebd9c95ef.mp4",
      specParams: {
        deviceSize: "498mmx265mmx749mm",
        totalWeight: "25.8kg",
        projectorWeight: "16.3kg",
        mirrorWeight: "9.3kg",
        btMountWeight: "2.2kg",
        bwMountWeight: "2.8kg",
        beMountWeight: "3.3kg",
        bshMountWeight: "12.5Kg",
      },
      electricSpecs: {
        inputPower: "100-240V/2-1A/50-60Hz, maximum 10A (3-pin C14 socket)",
        outputPower: "Projector AC circuit slot (3-pin C13 socket)",
      },
      operationSpecs: {
        tiltMode: "90° and 162°",
        panMode: "180°",
        positionError: "<0.03°",
        movementPrecision: "Translation or tilt in the same direction to the set position, with an error of approximately 0.01",
      },
      environmentSpecs: {
        temperatureRange: "5°-35°C",
        humidity: "20%-80%(无冷凝)",
      },
      textaerass: {
        titletext: "“Tribute to Life’s Rescuers” – Light and Shadow Performance Art",
        pagetext:
          "At the beginning of 2021, on the Tianjin Broadcasting Tower during the 2021 New Year’s Light Show, a 4-minute and 30-second piece of “light and shadow performance art” titled “Tribute to Life’s Rescuers” depicted a unique and heartwarming story.During the creative process, the production team utilized the hecoos Mirror Server-R media server to ensure the accurate presentation of the work. The projection reached its peak at 260 meters in height, perfectly synchronized on-site in real-time. The creative team employed tracking lenses, high-flow projectors, and the hecoos integrated media platform to seamlessly blend virtual and physical media to maintain the realism of the presentation and on-site performance. The projection system used autonomous lens calibration systems to precisely execute architectural projections. The simplicity and efficiency of the equipment enabled this piece to become a representative example of projection art.",
      },
      formData: {
        name: "",
        phone: "",
        city: "",
        email: "",
        company: "",
        position: "",
        message: "",
      },
    };
  },
  methods: {
    //     handleSubmit(event) {
    //   event.preventDefault();
    //   // 在此处添加表单提交后的处理逻辑，例如发送数据到服务器
    //   console.log(this.formData);
    // }
    // 显示视频播放器
    showVideo(n) {
      if(n == 1){
        this.videoUrl = "https://download.hecoos.com/enlightv/2025-11/f441eac9aa01246106ff61af11ddefd5.mp4"
      }else{
        this.videoUrl = "https://download.hecoos.com/enlightv/2025-11/639b0bf986e055fad0427e2ebd9c95ef.mp4"
      }
      this.showVideoPlayer = true;
      document.body.style.overflow = 'hidden'; // 禁止页面滚动
    },
    // 处理关闭视频
    handleCloseVideo() {
      this.showVideoPlayer = false;
      document.body.style.overflow = 'auto'; // 恢复页面滚动
    },
  },
};
</script>


<style scoped lang="scss">
@import "@/styles/en_pc/wsc.scss";
@import "@/styles/optimize_adaptation.scss";
</style>
